module.exports = __webpack_public_path__ + "img/GAME_RECYCLING.3d409b2a.png";